import {Injectable} from "@angular/core";

import {FeatureFlagsRequester} from "app/services/third-party/feature-flags/feature-flags-requester.service";
import {FeatureFlagsService} from "app/services/third-party/feature-flags/feature-flags.service";
import * as Models from "app/services/proxy/model/models";
import {getPlatformTypeOptions, resolvePlatformType, resolvePlatformTypes} from "app/services/ui/platform";

import {ControlOption} from "framework/ui/control-option";

@Injectable()
export class PlatformTypeService
{
    constructor(private readonly featureFlags: FeatureFlagsService,
               private readonly featureFlagsRequester: FeatureFlagsRequester)
    {
    }

    public get isFinOpsForAiEnabled(): boolean
    {
        return this.featureFlags.isEnabled(Models.CostFeatureFlags.cost_2604_a_finops_for_ai);
    }

    public registerFlag(): void
    {
        void this.featureFlagsRequester.registerFeatureFlagRequest(Models.FeatureFlagCategory.FEATURE,
                                                                    Models.CostFeatureFlags.cost_2604_a_finops_for_ai);
    }

    public resolve(platform: Models.Platforms): Models.Platforms
    {
        return resolvePlatformType(platform, this.isFinOpsForAiEnabled);
    }

    public resolveMany(platforms: Models.Platforms[] | undefined | null): Models.Platforms[] | undefined | null
    {
        return resolvePlatformTypes(platforms, this.isFinOpsForAiEnabled);
    }

    public getOptions(): ControlOption<Models.Platforms>[]
    {
        return getPlatformTypeOptions(this.isFinOpsForAiEnabled);
    }
}
